import mapboxgl, { Marker, Popup } from "mapbox-gl";
import { i18n } from "./i18n";
import { Throttle } from "./throttle";
import { getApmIcon, getMarkerUrl, isNonstop, postSelectedApm, setListTotal, setMapContainerHeight, setPaperBoxHeight, setRestrictedListHeight } from "./util";
import { isString, throttle } from "lodash";
import { setFilters } from "./storage";
class OSM {
    constructor(apms_url, selector = 'map') {
        this.edigitalPlaceId = 200526;
        this.edigitalDoorOpeningQrCodeUrl = 'https://foxpost.hu/uploads/documents/hu/qrkod.png';
        this.apms_url = apms_url;
        this.apms = [];
        this.apmsGeoJson = {
            'type': 'FeatureCollection',
            'features': []
        };
        var url = $('body').data('appTheme') === 'dark' ? 'foxpost-dark/style.json' : 'foxpost-light/style.json';
        if($('body').data('appTheme') == undefined || $('body').data('appTheme') == 'default'){
            url = 'foxpost-light/style.json'
        }
        this.map = new mapboxgl.Map({
            container: selector,
            style: 'https://osm.foxpost.hu/styles/' + url,
            center: [19.0562112, 47.4856034],
            minZoom: 6,
            zoom: 14,
        })
        this.apmsSource = null;
        this.setMapOptions();
        this.isEn();
        this.isSearching = false;
        this.isSendingRequest = false;
        this.setupFilterHandling();
        this.preFilteredApms = [];
        this.keyword = null;
        this.filters = {};
        this.sortedApms = [];
        this.map.on('load', async ()=>{
            await this.setMapEventHandlers();
            await this.loadData();
            const nav = new mapboxgl.NavigationControl({
                showCompass: false,
                showZoom: true,
                visualizePitch: false,
            })
            this.map.addControl(nav,'top-right')
        })
        $(document).on('view:map', (e, params) => {this.isSearching = false; this.map.resize()})
        this.generateListOnly = false;
        this.chunkedResults = []
        this.filteredApms = []
    }
    setMapOptions() {
        this.map.dragRotate.disable();
        this.map.touchZoomRotate.disableRotation();
        this.map.setMaxBounds([[16.11, 45.74], [22.9,48.58]]);
    }
    loadData(keyword) {
        $.getJSON(getMarkerUrl(),{keyword: keyword, filters:this.filters}).done((data) => {
            let markers = data.markers
            this.apms = data.list;
            this.sortedApms = data.list;
            this.apmsGeoJson = markers
            this.chunkResults(data.list)
            this.fillApmsNumber(data.count);
            this.drawMarkers(markers)
            this.generateAptListHtml();
            this.dropdownNoti();
            setListTotal(data.count);
        });
    }
    isEn(){
        let isEn = $('html').attr('lang').includes('en');
        return isEn;  
    }
    /** @deprecated */
    apmsToGeoJson(apms) {
        const features = [];
        for (const item of apms) {
            if(window.animatedMarker){
                if(window.animatedMarker.placeId == item.place_id){
                    continue
                }
            }
            const load = item.load || "";
            const icon = "overloaded" === load ? "marker-over-loaded" : "medium loaded" === load ? "marker-medium-loaded" : "marker-normal-loaded";
            const feature = {
                'type': 'Feature',
                'geometry': {
                    'type': 'Point',
                    'coordinates': [
                        item.geolng, item.geolat
                    ]
                },
                'properties': {
                    'place_id': item.place_id,
                    'icon': icon,
                }
            };
            features.push(feature);
        }
        return {
            'type': 'FeatureCollection',
            'features': features
        };
    }

    isClosestApmInBounds(apm){
        let bounds = this.map.getBounds()
        let clLng = apm.geolng
        let clLat = apm.geolat
        return (bounds._ne.lat > clLat && bounds._sw.lat < clLat ) && ( bounds._ne.lng > clLng && bounds._sw.lng < clLng)
    }
    setMapEventHandlers() {
        this.map.on('resize', ()=>{
            this.isSearching = false
            setMapContainerHeight()
        })

        this.map.on('movestart', (e) => {
            this.isSearching = true
        })

        this.map.on('moveend', (e) => {
            let validApms = this.validApmsInBounds()
            if(!this.isSearching) return;

            if(validApms.length == 0){
                this.map.zoomOut()
                return
            }

            this.isSearching = false
        });
        this.map.on('mouseenter', 'apms', (e) => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        // Change it back to a pointer when it leaves.
        this.map.on('mouseleave', 'apms', () => {
            this.map.getCanvas().style.cursor = '';
        });
        // Change the cursor to a pointer when the mouse is over the clusters layer.
        this.map.on('mouseenter', 'clusters', () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        // Change it back to a pointer when it leaves.
        this.map.on('mouseleave', 'clusters', () => {
            this.map.getCanvas().style.cursor = '';
        });
        this.map.on('click', 'clusters', (e) => {
            const features = this.map.queryRenderedFeatures(e.point, {
                layers: ['clusters']
            });
            const clusterId = features[0].properties.cluster_id;
            let _this = this;
            this.map.getSource('apms').getClusterExpansionZoom(
                clusterId,
                function (err, zoom) {
                    if (err)
                        return;
                    _this.map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                    });
                }
            );
        });

        this.map.on('click', ()=>{
            this.removeAnimatedMarker()
        })

        this.map.on('click', 'apms', (e) => {
            this.removeAnimatedMarker()
            let place_id = e.features[0].properties.place_id;
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = this.generatePopupHtml(place_id);
            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            // Calculate maximum popup width.
            const mapWidth = this.map._container.clientWidth;
            const popupWidth = mapWidth > 440 ? 400 : mapWidth - 100;
            // Documentation: https://docs.mapbox.com/mapbox-gl-js/api/markers/#popup
            const popup = new mapboxgl.Popup({ maxWidth: popupWidth + 'px', anchor: 'bottom', offset: [0, -40] })
                .setLngLat(coordinates)
                .setHTML(description);
            // Make sure the popup is fully visible.
            popup.on('open', () => {

                const point = this.map.project(popup._lngLat);

                const popupHeight = popup._container.clientHeight + 20 + 40; // a small amount of padding + vertical popup offset
                const popupWidth = popup._container.clientWidth + 40; // a small amount of padding on both sides

                const topOutside = point.y - popupHeight < 0;
                const leftOutside = point.x - (popupWidth / 2) < 0;
                const rightOutside = point.x + (popupWidth / 2) > mapWidth;

                if (topOutside || leftOutside || rightOutside) {
                    const topOffset = point.y - popupHeight;
                    let leftOffset = 0;
                    if (leftOutside && rightOutside)
                        leftOffset = point.x - mapWidth / 2; // pan the map so that the popup is centered
                    else if (leftOutside)
                        leftOffset = point.x - popupWidth / 2; // pan the map so that the left side of the popup is in screen
                    else if (rightOutside)
                        leftOffset = (point.x - mapWidth) + popupWidth / 2; // pan the map so that the right side of the popup is in screen
                    else
                        leftOffset = 0; // no panning required

                    this.map.panBy([leftOffset, topOffset]);
                }
            });

            popup.addTo(this.map);
            window.activePopup = popup;
            this.setAptPopupEvents();
            this.setSelectMarkerBtnHandling();
        });
    }
    generatePopupHtml(place_id) {
        let apm = this.apms.find(apm => apm.place_id === place_id);
        if (!apm)
            return;
        return this.getPopupTemplateHtml(apm);
    }
    fillApmsNumber(c) {
        $('.apt-count').html(c);
    }
    fillTypeAhead(typeaheadInputClass = '.js-typeahead-apt') {
        $.typeahead({
            minLength: 0,
            accent: true,
            // correlativeTemplate:true,
            maxItem: 15,
            debug: true,
            input: typeaheadInputClass,
            resultContainer: '#search-results',
            order: "desc",
            emptyTemplate: i18n.t('no result, for {{query}}', { 'query': '{query}' }),
            templateValue: "{{name}}, {{address}}",
            template:
             `
                <div class="mobile-apt">
                    <div class="apt-name">{{name}}</div>
                    <div class="apt-status"></div>
                    <div class "apt-city">{{city}}</div>
                    <div class "apt-address">{{address}}</div>
                    <div class="apt-details-text">
                        <button type="button">${i18n.t('Select')}</button>
                    </div>
                    <div class "apt-details">
                        <div class="findme">{{findme}}</div>
                        <div class="filling">${i18n.t('Filling and emptying time')}</div>
                        <div class="filling-time"></div>
                        <div class="opening">${i18n.t('Opening')}</div>
                        <div class="opening-hours"></div>
                    </div>

                </div>
            `,
            source: {
                display: ["city", "zip"],
                data: this.getSortedApms(),
            },
            callback: {
                onClickAfter: (node, a, item, event) => {
                    let apm = this.apmsGeoJson.features.find((apm) => apm.properties.place_id === item.place_id);
                    event.preventDefault();
                    //clearMarkerAnimation();

                    this.map.flyTo({
                        center: apm.geometry.coordinates
                    });
                    /**
                     * TODO: select in left side list
                     */
                    // this.selectAptInList(item.place_id);
                    let apmSelectionMobile = this.apms.find(apm => apm.place_id === $(event.target).data('place-id'));
                    postSelectedApm(apmSelectionMobile);
                },
                onResult: Throttle.throttle((node, query, result, resultCount, resultCountPerGroup) => {
                    
                    const isZip = /[0-9]{4}/.test(query) && query.length == 4;
                    let flyToCoords = []
                    if(resultCount == 0){
                        if(isZip){
                            
                           
                            
                        }else{
                            
                            
                        }
                    }

                    

                    
                }, 800),
            }
        });
    }
    getPopupTemplateHtml(apm) {

        return `
            <div class="apm-popup">
                <div class="apm-popup-col_icon">
                    <img src=${apm.iconUrl}>
                </div>
                <div class="apm-popup-col_details">
                    <div class="apm-popup-name">
                    <p class="apt-list__item-name">${apm.name}</p>
                    <!--${this.getLoadIconHtml(apm)}-->
                    </div>
                    <div class="apm-popup-city">
                    <span class="apt-list__item-city">${apm.city}</span>
                    </div>
                    <div class="item-col_details_icons">
                    ${this.getPaymentOptionsIconHtml(apm)}
                    </div>
                    <div class="apm-popup-address">
                    <p class="apt-list__item-address">${apm.address}</p>
                    <a href="#" class="apt-list__item-collapse js-collapse" data-collapse-target="#apt-popup-details-${apm.place_id}">${i18n.t('Details')}</a>
                    </div>
                    <div class="apm-popup-select-apm">
                        <a class="btn btn-red button__select-apt" href="#" data-place-id="${apm.place_id}">${['z-pont', 'z-point'].includes(apm.variant.toLowerCase()) ? i18n.t('Select parcel point') : i18n.t('Select parcel locker')}</a>
                    </div>
                    <div class="apm-popup-details" id="apt-popup-details-${apm.place_id}" style="display: none;">
                        <hr class="apm-popup-divider"/>
                        <div class="apm-popup-findme">
                            <p>${apm.findme}</p>
                        </div>
                        <div class="apm-popup-fill">
                            <p>${this.getFillEmptyList(apm.fillEmptyList)}</p>
                        </div>
                        <div class="apm-popup-open">
                            <p><b>${i18n.t('Open')}</b></p>
                            <p>${this.getOpenHoursHtml(apm.open)}</p>
                        </div>
                        <div class="apm-popup-loading-state">
                            <p>${this.getLoadedStateString(apm.load, apm.variant)}</p>
                        </div>
                    </div>
                </div>
            </div> 
        `;
    }
    getLoadedStateString(load, variant = '') {
        // z-pont, z-point, z-box load state will be allways unreachable at the moment.
        if (['z-pont', 'z-point', 'z-box'].includes(variant.toLowerCase())) {
            return i18n.t('Currently, we do not have information about the occupancy.');
        }

        let load_str = "";
        switch (load) {
            case 'overloaded':
                //load_str = i18n.t('The locker is moderately saturated, in case of parcel delivery there may be no free slot, the delivery delay is expected on average 1 day.');
                load_str = i18n.t('The locker is very saturated, there may be no free compartment when sending parcels, delivery is expected to be 2-3 days late.');
                break;
            case 'medium loaded':
                load_str = i18n.t('The locker is moderately saturated, in case of parcel delivery there may be no free slot, the delivery delay is expected on average 1 day.');
                break;
            case 'normal loaded':
                load_str = i18n.t('The locker is not saturated, parcel delivery is uninterrupted, there is no delivery delay.');
                break;
            default:
                load_str = i18n.t('Currently, we do not have information about the occupancy.');
                break;
        }
        return load_str
    }
    getFillEmptyList(fillAndEmptyList){
        let html = '<b>'+ i18n.t('Filling and emptying time') + ':</b><br> ' + i18n.t('on weekdays') + ' ';
        if(fillAndEmptyList.length>1){
            $.each(fillAndEmptyList, (i, o) => {
                if(this.isEn()){
                    html += fillAndEmptyList[i].emptying.slice(0,-3) + "-" + fillAndEmptyList[i].filling.slice(0,-3) + " and "
                }else{
                    html += fillAndEmptyList[i].emptying.slice(0,-3) + "-" + fillAndEmptyList[i].filling.slice(0,-3) + " és "
                }
            })
            const htmlString = html
            let htmlStringWithoutLastES = ""
            htmlStringWithoutLastES =  htmlString.slice(0,-4)
            if(this.isEn()){
                htmlStringWithoutLastES += '.';
            }else{
                htmlStringWithoutLastES += ' között.';
            }
            return htmlStringWithoutLastES
        }
        else{
            if(fillAndEmptyList.length < 1){
                html += i18n.t('unknown') + '.';
                return html;
            }
            else{
                $.each(fillAndEmptyList, (i, o) => {
                    html += fillAndEmptyList[i].emptying.slice(0,-3) + "-" + fillAndEmptyList[i].filling.slice(0,-3)
                })
                html += this.isEn() ? '.' : ' között.';
                return html;
            }
        }
    }
    getOpenHoursHtml(opening) {
        let html = '<table class="opening__table"><tbody>';
        $.each(opening, (i, o) => {
            html += "<tr><td>" + i18n.t(this.getOpeningHoursKeyMapping()[i]) + "</td><td>" + o + "</td>"
        })
        html += '</tbody></table>';
        return html
    }
    getOpeningHoursKeyMapping() {
        if(this.isEn()){
            return {
                Monday: "Monday",
                Tuesday: "Thuesday",
                Wednesday: "Wednesday",
                Thursday: "Thursday",
                Friday: "Friday",
                Saturday: "Saturday",
                Sunday: "Sunday",
            }
        }else{
            return {
                hetfo: "Monday",
                kedd: "Thuesday",
                szerda: "Wednesday",
                csutortok: "Thursday",
                pentek: "Friday",
                szombat: "Saturday",
                vasarnap: "Sunday",
            }
        }
    };

    dropdownNoti(){
        $('.mobile-triangle').on('click', (event) => {
            $('.dropdown-mobile-noti').toggle();
            $('.loaded-desc-mobile').toggle();
            $(event.target).toggleClass('open')
            setTimeout(setMapContainerHeight(), 100);
        });

        $('.mobile-table').on('click', (event) => {
            $('.mobile-triangle').trigger("click");
        });
    }

    generateAptListHtml(mapZoomApms = [], onlyCities = false, event = 'click') {
        $('.no-results').hide();
        let listContainer = $('.list-items');
        let restrictedListContainer = $('#apt-list-restricted');
        let qrCodeImg = '';
        let qrCodeImgDetail = '';
        let hasDiscountedApt = false;
        let apms = [];
        apms = this.chunkedResults.shift()  || [];
        if(apms.length == 0 && this.isSearching && !this.generateListOnly){
            if(this.isKeywordZip())
                apms = this.searchNearestApmsByZip()
            else
                this.searchNearestApmsByGeo()
        }
        else{
            if(this.isSearching && !this.generateListOnly) {
                this.isSearching = false
                this.map.flyTo({
                    center: [apms[0].geolng, apms[0].geolat ],
                    zoom: 14
                })
            }
        }
        $('.apt-list li').remove()
        restrictedListContainer.html(null)
        let listItemTemplate = "";
        let restrictedListItemTemplate = "";
        if(this.chunkedResults.length > 0 ){
            const _r = this.chunkedResults.shift()
            apms.push(..._r)
        }
        $.each(apms, (key, apm) => {
            if (this.isAptDiscounted(apm)) hasDiscountedApt = true;
            if (apm.place_id === this.edigitalPlaceId) {
                qrCodeImg = '<div><div class="apt-qr-title">' + i18n.t('Door opening QR code') + ':</div></div><img alt="Qr" class="apt-qr-img apt-qr-img--edigital" src="' + this.edigitalDoorOpeningQrCodeUrl + '"></div>';
                qrCodeImgDetail = '<span><span class="apt-qr-title">' + i18n.t('Door opening QR code') + ':</span></span><img alt="Qr" class="apt-qr-img apt-qr-img--edigital" src="' + this.edigitalDoorOpeningQrCodeUrl + '"></div>';
            }
                listItemTemplate += this.getListItemTemplate(apm, qrCodeImg, qrCodeImgDetail)
        });
        listContainer.append(listItemTemplate)
        if (!hasDiscountedApt) {
            $('.checkbox__container').hide();
        }
        listContainer.append('<li class="apt-list__back-to-top hidden"><a href="#apt-list__header" title="' + i18n.t('Jump to top') + '" class="apt-list__back-to-top-link"></a></li>');
        
        this.setSelectBtnHandling();
        this.setAptListEventHandling();
        if(this.isMapVisible() && this.isSearching){
            setRestrictedListHeight()
            setMapContainerHeight()
        }
        if(this.isExactMatchByName(apms) && event == 'click'){
            postSelectedApm(apms[0])
            this.map.setCenter([apms[0].geolng, apms[0].geolat])
            setTimeout(()=>this.setBouncingMarker(apms[0]), 100)
        }

    }
    setAptPopupEvents() {
        let _this = this
        $('.apm-popup .js-collapse').on('click', function (e) {
            e.preventDefault();
            const $this = $(this);
            let collapseTarget =  $($this.data('collapse-target'))
            $this.toggleClass('collapsed');
            collapseTarget.toggleClass('collapsed');            
            collapseTarget.toggle()
            if(_this.isMapVisible()){
                _this.map.panBy([0, $('div.mapboxgl-popup-content').offset().top - 140 ])
            }
        });
        $('.apm-popup .button__select-apt').on('click', (e)=>{
            let apm = this.getSortedApms().find((apm) => apm.place_id === $(e.target).data('place-id'));  
            postSelectedApm(apm)
            if(window.activePopup){
                window.activePopup.remove()
                window.activePopup = null
            }
            this.setBouncingMarker(apm)
        })
        $('.apm-popup .mapboxgl-popup-close-button-redesign').on('click', (e)=>{
            e.preventDefault()
            this.map.fire('closeAllPopups')
        })
    }
    setAptListEventHandling() {
        $('.apt-list .apt-list__item-buttons a.button__jump-to,#apt-list-restricted .apt-list__item-buttons a.button__jump-to').off()
        $('li.apt-list__item > .apt-list__item-col').off()
        $('span.apt-list__item-header').off()
        $('.apt-list__back-to-top-link').off()
        $('.list-items .js-collapse').off()
        $('.apt-list .apt-list__item-buttons a.button__jump-to,#apt-list-restricted .apt-list__item-buttons a.button__jump-to').on('click',(e) => {
            e.preventDefault();
            let placeId = $(e.target).data('place-id') || $(e.target).parent().data('place-id')
            let apm = this.getSortedApms().find((apm) => apm.place_id === placeId);
            if(this.isFromRestrictedDropdown(e.target)){
                $('#apt-list-restricted').hide()
                setMapContainerHeight()
            }else if(this.isFromPaperBox(e.target)){
                setPaperBoxHeight();
            }  
            this.setBouncingMarker(apm, true)
            this.map.flyTo({
                center: [apm.geolng, apm.geolat]
            });

        })

        $('.list-items .js-collapse').on('click', (e) => {
            try {
                e.preventDefault();
                let el = $(e.target).parents('li')[0]
                let apmId = $(el).data('place-id')
                $(`.apt-list__item-hidden-${apmId}`).toggleClass('collapsed')
                let detailsBtn = $(el).find('a.js-collapse')[0];
                if(detailsBtn){
                    $(detailsBtn).toggleClass('collapsed')
                }
            } catch (e){
                return
            }
        })
        $('span.apt-list__item-header').on('click', (e) => {
            try {
                e.preventDefault();
                let el = $(e.target).parents('li')[0]
                let apmId = $(el).data('place-id')
                $(`.apt-list__item-hidden-${apmId}`).toggleClass('collapsed')
                let detailsBtn = $(el).find('a.js-collapse')[0];
                if(detailsBtn){
                    $(detailsBtn).toggleClass('collapsed')
                }
            } catch (e){
                return
            }
        })
        $('.apt-list__back-to-top-link').on('click', (e)=>{
            e.preventDefault()
            let list = $("#apt-list")
            if(list.is(':visible')) list.scrollTop(0)
        });
    }
    isAptDiscounted(apm) {
        return apm.sdapt === 'X' ? ' apt-list__item--discounted' : '';
    }
    getRedButtonStyle() {
        return 'margin-top:5px;display:inline-block;background: white;border-radius: 3px;color:#B70100;border: 2px solid #B70100;padding: 5px 8px;text-decoration: none;';
    }
    getLoadIconHtml(apm) {
        let title = this.getLoadedStateString(apm.load, apm.variant)
        return '<img data-placement="top" data-toggle="popover" data-container="body data-trigger="focus" ' + ' alt = "' + title + '"' + ' title = "' + title + '"' + ' datacontent = "' + title + '"' + 'class = "apt-list__item-load-indicator"' + 'src = assets/images/' + this.getLoadIconMapping()[this.getAptLoadIconName(apm.load)] + '>';
    }
    getPaymentOptionsIconHtml(apm) {
        return `
            <span class="item-col_details_icons-container">
                <img src="assets/images/cash.svg" width=25 class="${apm.cashPayment ? '' : 'd-none'}" title="${i18n.t('Payment in cash')}">
                <img src="assets/images/credit-card.png" width=25 class="${apm.cardPayment ? '' : 'd-none'}" title="${i18n.t('Payment by card')}">
                <img src="assets/images/payment-link.svg" width=20 class="${apm.paymentOptions.includes('link') ? '' : 'd-none'}"  title="${i18n.t('Payment via link')}">
                <img src="assets/images/app.svg" class="${apm.paymentOptions.includes('app') ? '' : 'd-none'}" title="${i18n.t('Payment via Packeta app')}">
            </span>
        `;
    }
    getAptLoadIconName(load) {
        if ('overloaded' === load) {
            return 'overLoadedIcon';
        }
        if ('medium loaded' === load) {
            return 'mediumLoadedIcon';
        }
        return 'normalLoadedIcon';
    }
    getLoadIconMapping() {
        return {
            'normalLoadedIcon': 'indicator-normal-loaded.png',
            'mediumLoadedIcon': 'indicator-medium-loaded.png',
            'overLoadedIcon': 'indicator-over-loaded.png'
            //'overLoadedIcon': 'indicator-medium-loaded.png'
        };
    }
    getSortedApms() {
        return this.sortedApms
    }
    setAptListFilter() {

        $('#apt-list-filter, #apt-list-filter-paper-box').on('keypress',(e) => {
            if(e.which != 13) return
            this.searchApms(true)
        });

        $('#apt-list-filter, #apt-list-filter-paper-box').on('keyup', throttle((e) => {
            this.keyword = e.target.value;
            this.generateListOnly = true;
            this.chunkResults(this.getKeywordFilteredApms())
            this.generateAptListHtml([], false, 'keyup');
            this.generateListOnly = false;
        }, 400));

        $('#only-discounted-apt-cb').on('change', () => {
            /**
             * TODO: refakt
             */
            const isChecked = $('#only-discounted-apt-cb').prop('checked');
            const keyWord = $.trim($('#apt-list-filter').val());
            const re = new RegExp(this.escapeRegExp(keyWord), 'i');

            $('.apt-list__item').show().filter(function () {
                //filter for only discounted apts
                if (isChecked) {
                    if ('' !== keyWord) {
                        // filter for keyword as well
                        return !re.test($(this).text()) || !$(this).hasClass('apt-list__item--discounted');
                    } else {
                        return !$(this).hasClass('apt-list__item--discounted');
                    }
                } else {
                    // filter for all apts
                    return !re.test($(this).text());
                }
            }).hide();
        });

    }
    escapeRegExp(string) {
        string = String(string);
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    toggleBackToTop() {
        $('.apt-list__back-to-top').toggleClass('hidden', $('.apt-list').scrollTop() < 600);
    }
    handleAptSelectEvent(event){
        let apm = this.apms.find(apm => apm.place_id === $(event.target).data('placeId'));
        postSelectedApm(apm);
        if(this.isFromPaperBox(event.target)){
            setPaperBoxHeight()
        }
        let parent = $(event.target).parents('li')
        if(parent[0]){
            parent.addClass('active')
        }
        this.setBouncingMarker(apm)
        this.map.setCenter([apm.geolng, apm.geolat])
        if(!$('#map').is(':visible')){
            $('#viewToggle').trigger('click')
        }
    }
    setSelectBtnHandling(){        
        $('.button__select-apt').on('click',event => this.handleAptSelectEvent(event));
    }
    setSelectMarkerBtnHandling(){
        $('.marker-select-apt').on('click',event => this.handleAptSelectEvent(event));
    }
    selectAptInList(placeId) {
        let itemsHeight = 0;
        let selected = false;
        $('.apt-list__item').removeClass('active').each(function (e, i) {
            const $this = $(this);
            if ($this.attr('id') === 'apt-list__item-' + placeId) {
                selected = true;
            }
            if (!selected) {
                itemsHeight += parseInt($this.css('height').replace('px', ''));
            }
        });

        const $li = $('#apt-list__item-' + placeId);
        // const index = $li.siblings(':visible').addBack().index($li);
        const scrollTop = itemsHeight + parseInt($('.checkbox__container').css('height').replace('px', ''));

        $li.addClass('active');
        $('.apt-list').animate({ scrollTop: scrollTop }, 'slow');
    };

   drawMarkers(apmSource) {
    this.removeAllMarkers();
    let source = apmSource
    this.map.addSource('apms', {
        'type': 'geojson',
        'data': source,
        cluster: true,
        clusterMaxZoom:11,
        clusterRadius: 50,
        generateId: true,
    });
    const markers = [{
        name: 'marker-normal-loaded',
        url: 'assets/images/marker-normal-loaded.png'
    }, {
        name: 'marker-medium-loaded',
        url: 'assets/images/marker-medium-loaded.png'
    }, {
        name: 'marker-over-loaded',
        url: 'assets/images/marker-over-loaded.png'
    },{
        name: 'marker-no-info',
        url: 'assets/images/marker-no-info.png'
    },{
        name: 'marker-z-box',
        url: 'assets/images/marker-z-box.png'
    },{
        name: 'marker-z-point',
        url: 'assets/images/marker-z-point.png'
    }];
    let markersLoaded = 0;
    $.each(markers, (i, marker) => {
        this.map.loadImage(marker.url, (error, image) => {
            // TODO: improve error handling
            if (error)
                throw error;
            if(!this.map.hasImage(marker.name))
                this.map.addImage(marker.name, image);
        });
    })
    // All images have been loaded – add layers to the map.
    this.map.addLayer({
        'id': 'clusters',
        'type': 'circle',
        'source': 'apms',
        'filter': ['has', 'point_count'],
        'paint': {
            'circle-color': '#FFFFFF',
            'circle-radius': [
                'step',
                ['get', 'point_count'],
                17.5,
                25, 20,
                50, 22.5
            ],
            'circle-stroke-width': [
                'step',
                ['get', 'point_count'],
                4,
                25, 5,
                50, 6
            ],
            'circle-stroke-color': '#B70100',
            "circle-translate-transition": {
                delay: 0,
                duration: 0,
            }
        }
    });
    this.map.addLayer({
        'id': 'cluster-count',
        'type': 'symbol',
        'source': 'apms',
        'filter': ['has', 'point_count'],
        'layout': {
            'text-field': '{point_count_abbreviated}',
            'text-font': ['Arial Unicode MS Bold'],
            'text-size': 12,
            'text-allow-overlap': true,
            'text-ignore-placement': true
        },
        'paint': {
            'text-color': '#B70100',
            "icon-translate-transition":{
                delay: 0,
                duration: 0,
            },
        },
    });
    this.map.addLayer({
        'id': 'apms',
        'type': 'symbol',
        'source': 'apms',
        'filter': ['!', ['has', 'point_count']], // clustering
        'layout': {
            'icon-image': ['get', 'icon'],
            'icon-anchor': 'bottom',
            'icon-size': [
                'interpolate',
                ['linear'],
                ['zoom'],
                14, 0.5,
                20, 0.75
            ],
            'icon-allow-overlap': true,
            'icon-ignore-placement': true
        }
    });

   }
   removeAllMarkers(){
    if(this.map.getSource('apms')){
        if(this.map.getLayer('clusters'))
            this.map.removeLayer('clusters')
        if(this.map.getLayer('cluster-count'))
            this.map.removeLayer('cluster-count')
        if(this.map.getLayer('apms'))
            this.map.removeLayer('apms')
        this.map.removeSource('apms')
    }
   }
   handleSearchButtons(){
    if(this.keyword.length === 0){
        $('#aptSearchButton, #searchButtonPaperBox').show();
        $('#searchClearButton, #searchClearButtonPaperBox').hide();
    }else{
        $('#searchClearButton, #searchClearButtonPaperBox').show();
        $('#aptSearchButton, #searchButtonPaperBox').hide();
    }
   }
   isFromRestrictedDropdown(element){
    return $(element).parents('div')[0].id === "apt-list-restricted"
   }
   isFromPaperBox(element){
    let boxParent = $(element).parents('div').filter((p, k)=>{
       return  $(k).attr('id') == 'filterPanel'
    });
    return boxParent.length > 0

   }
   isMapVisible(){
    return $('.map-container').is(':visible')
   }

   setupFilterHandling(){
        $(document).on("filters:changed", (e, params) => this.updateOnFilters(e, params))
        $(document).on("filters:restored", (e, filters) => {
            this.filters = filters
            Object.keys(this.filters).forEach((v, i) => {
                let el = $(`.${v}_counter`)
                el.text(this.filters[v].length);
                el.show()
            })
        })
   }

   updateOnFilters(event, params){
        this.filters = params.filters
            $.getJSON(getMarkerUrl(), { keyword:this.keyword, filters:this.filters }).done((response) => {
                this.apmsGeoJson = response.markers
                this.apms = response.list;
                this.sortedApms = response.list;
                this.chunkResults(response.list)
                this.generateAptListHtml(response.list)
                this.drawMarkers(response.markers)
                this.filteredApms = response.list
                setListTotal(response.count);
            })

            return

   }

    getKeywordFilteredApms(onlyCities = false){
        if(!this.keyword || this.keyword.length === 0) return this.apms
        let keywordLC = this.keyword.toLowerCase()
        let filteredApms = [];

        /** strict search by city name */
        filteredApms = this.apms.filter((apm)=>
            apm.city.toLowerCase() === keywordLC ||
            this.getUnicodeString(apm.city.toLowerCase()) === keywordLC
        )
        if(filteredApms.length > 0)
            return filteredApms;
       
        if(onlyCities)
             return [];
        /** wildcard search by any property */
        let propsToSearch = ['city', 'address', 'place_id', 'operator_id', 'name']
        filteredApms = this.apms.filter((apm)=>{
            let _res = []
            $.each(propsToSearch,(i, prop)=>{
              _res.push(this.getUnicodeString(apm[prop]).toLowerCase().includes(this.getUnicodeString(keywordLC)))
            });
            return _res.includes(true)
        })
        if(filteredApms.length > 0)
            return filteredApms;

        return []
    }
    /** @deprecated */
   applyFilters(data){
    return
        if(this.filters.length === 0) return data
        let filtered = []

        filtered.push(
        ...data.filter((apm) =>
                    this.filters.includes("outside") ? apm.isOutdoor == true : true
                ).filter((apm) =>
                    this.filters.includes("saturday") ? Object.keys(apm.open).includes("szombat") : true
                ).filter((apm) =>
                    this.filters.includes("sunday") ? Object.keys(apm.open).includes("vasarnap") : true
                ).filter((apm) =>
                    this.filters.includes("load-low") ? apm.load === 'normal loaded' : true
                ).filter((apm) =>
                    this.filters.includes("nonstop") ? isNonstop(apm.open) : true
                ).filter((apm) =>
                    // TODO: implement logic if foreign apms are present
                    this.filters.includes("card") ? true : true
                )
        )
        if(window.animatedMarker){
            let _apm = filtered.find((apm)=>apm.place_id == window.animatedMarker.placeId)
            if(!_apm) this.removeAnimatedMarker();
        }
    return filtered;
   }
   isKeywordZip(){
        return /^[0-9]{4}$/.test(this.keyword)
   }
   searchNearestApmsByZip(){
        let zipLimit = 10;
        let apms = []
        while(apms.length < 3 && zipLimit < 1000){
            apms = [];
            apms.push(...this.getSortedApms().filter((apm) => parseInt(apm.zip) <= (parseInt(this.keyword)+parseInt(zipLimit)) && parseInt(apm.zip) >= (parseInt(this.keyword)-parseInt(zipLimit)) ))
            zipLimit += 10;
        }
        apms = this.applyFilters(apms)
        this.map.flyTo({
            center: [apms[0].geolng, apms[0].geolat ],
            zoom: 12
        })
        return apms
   }
   searchNearestApmsByGeo(){
        if(this.isSendingRequest ) return;
        this.isSendingRequest = true
        $.ajax(
            {
                url: `${window.location.origin + window.location.pathname}geo.php?name=${this.keyword}`,
                method: 'GET',
            }
            ).then(
            (response) => {
                this.isSendingRequest = false
                if(response.status){
                    if(response.status == 500) alert(`${this.keyword} koordinátái nem meghatározhatóak!`)
                }
                let res = response
                if(Object.keys(res).includes('longitude') && Object.keys(res).includes('latitude')){
                    this.map.flyTo({
                        center: [res.longitude, res.latitude ],
                        zoom: 12
                    })
                } else {
                    $('.no-results').show();
                }
            }).catch((e)=>{
                this.isSendingRequest = false
                $('.no-results').show();
            })
   }
   reset(){
    this.keyword = ""
    this.isSearching = false
    this.preFilteredApms = []
    this.filters = {};
    
    $('.filter-group-counter').text('');
    $('.filter-group-counter').hide();
    $('input[type="checkbox"]').prop('checked', false);
    setFilters({});
    $(document).trigger('filters:changed', {filters:{}});
   }

   getUnicodeString(data) {
    if(!isString(data)) return toString(data)
    return data.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
   }

   getFilteredApms(onlyCities = false){
   
    this.chunkResults(this.filteredApms);
    return this.filteredApms 

   }
   setBouncingMarker(selectedApm, pulse = false){
    let animationClass = pulse ? 'pulse' : 'bouncing'
    this.removeAnimatedMarker()
    const apmLayerData = this.apmsGeoJson.features.filter(
        (apm)=> apm.properties.place_id != selectedApm.place_id
    )
    const filteredFeatures = {
        type: 'FeatureCollection',
        features: apmLayerData
    }
    this.map.getSource('apms').setData(filteredFeatures);

    const icon = getApmIcon(selectedApm);

    let el = document.createElement('div')
    el.className= `apm-popup marker ${animationClass} marker-${selectedApm.place_id} ${icon}`;
    const mapWidth = this.map.getContainer().clientWidth;
    const popupWidth = mapWidth > 440 ? 400 : mapWidth - 100;
    const coords = [selectedApm.geolng, selectedApm.geolat]
    const popup = new Popup({ maxWidth: popupWidth + 'px', anchor: 'bottom', offset: [0, -40] })
    .setLngLat(coords)
    .setHTML(this.generatePopupHtml(selectedApm.place_id));
    popup.on('open', () => this.setAptPopupEvents())
    const m = new Marker(el, {})
    .setLngLat(coords)
    .setOffset([0, -20])
    .setPopup(popup)
    .addTo(this.map)
    
    window.animatedMarker = {
        'placeId': `${selectedApm.place_id}`,
        'marker': m,
    };
   
   }
   removeAnimatedMarker(){
    if(window.animatedMarker){
        window.animatedMarker.marker.remove()
        window.animatedMarker = undefined
        this.map.getSource('apms').setData(this.apmsGeoJson)
    }
   }
   isExactMatchByName(results = []){
    if(results.length != 1 || this.keyword.length === 0)
        return false;    
    if(this.getUnicodeString(results[0].name.toLowerCase()) !== this.getUnicodeString(this.keyword.toLowerCase()))
        return false
    return true
   }

    validApmsInBounds(){
        let boundary = this.map.getBounds();
        let fApms = this.apms.filter((apm)=>(apm.geolng < boundary._ne.lng && apm.geolat < boundary._ne.lat) && (apm.geolng > boundary._sw.lng && apm.geolat > boundary._sw.lat))
        return fApms;
    }
    searchApms(onlyCities = false){
        const isChecked = $('#only-discounted-apt-cb').prop('checked');
        const sb = $('#apt-list-filter');
        const sbp = $('#apt-list-filter-paper-box');
        let keyWord = "";
        if($(sb).is(':visible'))
            keyWord = $(sb).val().trim();
        else
            keyWord = $(sbp).val().trim();

        if(keyWord !== this.keyword){
            this.preFilteredApms = []
        }
        this.keyword = keyWord
        this.handleSearchButtons();
        if(this.keyword.length < 1) {
            $('#apt-list-restricted').hide()
            setMapContainerHeight()
            return
        }
        this.isSearching = true;
        this.generateListOnly = false
        $.getJSON(getMarkerUrl(), { keyword:this.keyword, filters:this.filters }).done((response) => {
            this.apmsGeoJson = response.markers;
            this.sortedApms = response.list;
            this.chunkResults(response.list)
            this.filteredApms = response.list
            this.generateAptListHtml(response.list, onlyCities)
            this.drawMarkers(response.markers)
            if(this.isMapVisible()){
                $('#apt-list-restricted').show()
                setRestrictedListHeight()
                setMapContainerHeight()
            }
            setListTotal(response.count);
        })
    }
    getClosestApmId(){
        if(this.isSendingRequest) return;
        return $.ajax({
            url: 'closest_apm.php',
            method: 'GET',
            headers:{
                'Accept': 'application/json',
            },
        })
    }
    getListItemTemplate(apm, qrCodeImg, qrCodeImgDetail){
        let discountedPriceText = i18n.t('Discounted price');
        let showOnMapText = i18n.t('Show on map');
        let selectText = i18n.t('Select');
        let detailsText = i18n.t('Details');
        let discountEnabled = !!$('body').data('discount');
        let paymentOptionsIconHtml =  this.getPaymentOptionsIconHtml(apm);
        return '<li id="apt-list__item-' + apm.place_id + '" class="apt-list__item' + this.isAptDiscounted(apm) + '" data-place-id="' + apm.place_id + '">'
                + '<div class="item-row">'
                + '<div class="item-col_icon">'
                + '<span class="apt-list__item-header">'
                + `<div ><img src=${apm.iconUrl}></div>`
                + '</div>'
                + '<div class="item-col_header">'
                + '<span class="apt-list__item-header-row">'
                + '<span class="apt-list__item-name">'+ apm.name                  
                + '<span class="apt-list__item-inline-btn-container">' 
                + '</span>'
                + '</span>'
                + (discountEnabled ? '<span title="' + discountedPriceText + '" class="apt-list__item-discount">' + discountedPriceText + '</span>' : '')
                + '</span>'// end of row 1
                + '<span class="apt-list__item-header-row">'
                + '<span class="apt-list__item-city d-none">' + apm.city + '</span>'
                + '</span>'// end of row 2
                + '<span class="apt-list__item-address-row">'
                + '<span class="apt-list__item-address">' + apm.address + '</span>'
                + '</div>'
                + '<div class="item-col_details">'
                + '<div class="item-col_details_icons">'
                   + paymentOptionsIconHtml
                + '</div>'
                + '<a href="#" class="apt-list__item-collapse js-collapse" data-collapse-target=".apt-list__item-hidden-' + apm.place_id + '">' + detailsText + '</a>'
                + '</span>'
                + '</span>'// end of header
                + '</div>'
                + '</div>'
                + '<span class="d-none apt-list__item--hidden apt-list__item-hidden-' + apm.place_id + '">' + qrCodeImgDetail
                + '<div>'
                + '<span class="apt-list__item-find-me">' + apm.findme + '</span>'
                + '<span class="apt-list__item-fillempty">' + this.getFillEmptyList(apm.fillEmptyList) + '</span>'
                 + '</div>'
                + '<div>'
                + '<span class="apt-list__item-opening"><b>' + i18n.t('Open') + ':</b></span>'
                + '<span class="apt-list__item-opening">' + this.getOpenHoursHtml(apm.open) + '</span>'
                + '<span class="apt-list__item-loaded-state-bottom">' + this.getLoadedStateString(apm.load, apm.variant) + '</span><br />'
                + '<span class="apt-list__item-loaded-state">' + this.getLoadedStateString(apm.load, apm.variant) + '</span>'
                + '</div>'
                + '<span class="apt-list__item-buttons">'
                + '<a class="btn btn-red button__jump-to" href="#" data-place-id="' + apm.place_id + '">' + showOnMapText + '</a>'
                + '<a class="btn btn-red button__select-apt" href="#" data-place-id="' + apm.place_id + '">' + selectText + '</a>'
                + '</span>'
                + '</span>'
                + '<span class="apt-list__item-buttons outer">'
                + `<a class="btn btn-red button__jump-to" href="#" data-place-id="${apm.place_id}"></a>`
                + `<a class="btn btn-red button__select-apt" href="#" data-place-id="${apm.place_id}"><span class="material-symbols-outlined" data-place-id="${apm.place_id}">check</span>`
                + `<span class="btn-text" data-place-id="${apm.place_id}"></span></a>`
                + '</span>'
                + '</li>';
    }
    chunkResults(data) {
        const chunkSize = 30;
        const chunks = [];
        for (let i = 0; i < data.length; i += chunkSize) {
            chunks.push(data.slice(i, i + chunkSize))
        }
        this.chunkedResults = chunks
    }
    addChunkToList(){
        const _r = this.chunkedResults.shift()
        let _content = ""
        let _content_r = ""
        let qrCodeImg = ""
        let qrCodeImgDetail = ""
        $.each(_r ,(k, e) => {
            if (e.place_id === this.edigitalPlaceId) {
                qrCodeImg = '<div><div class="apt-qr-title">' + i18n.t('Door opening QR code') + ':</div></div><img alt="Qr" class="apt-qr-img apt-qr-img--edigital" src="' + this.edigitalDoorOpeningQrCodeUrl + '"></div>';
                qrCodeImgDetail = '<span><span class="apt-qr-title">' + i18n.t('Door opening QR code') + ':</span></span><img alt="Qr" class="apt-qr-img apt-qr-img--edigital" src="' + this.edigitalDoorOpeningQrCodeUrl + '"></div>';
            }
            _content += this.getListItemTemplate(e, qrCodeImg, qrCodeImgDetail)
        });
        $('.list-items').append(_content)
        this.setAptListEventHandling();
    }
    handleFilters(e){
        $('.filter').on('change', (e)=>{
            const type = $(e.target).data('filter-type');
            const v = e.target.value;
            if(!Object.keys(this.filters).includes(type)) this.filters[type] = []

            if(this.filters[type].includes(v)){
                this.filters[type].splice(this.filters[type].indexOf(v), 1)
            }else{
                this.filters[type].push(v)
            }
            let typeLength = this.filters[type].length;
            let counterContent = typeLength > 0 ? `${typeLength}` : '';
            let counterEl = $(`.${type}_counter`)
            if(counterContent.length > 0){
                counterEl.text(counterContent)
                counterEl.show()
            }else{
                counterEl.text('')
                counterEl.hide();
            }
            

            if(this.filters[type].length == 0)
                delete this.filters[type]
            setFilters(this.filters)
            this.removeAnimatedMarker()
            $(document).trigger('filters:changed', {filters:this.filters});
        })
    }
    setSearchClearButtonEvent(){
        $('.resetFiltersButton').on('click', () => {
            if(!Object.keys(this.filters).length) return;
            this.reset();
        })
    }
}
export { OSM }
